import { clearKeyFromDB } from "@/features/encryption/utils/storage";
import { SubscriptionRow } from "@/services/api/fetchers/subscription";
import { deleteStore } from "@/shared/utils/indexdb";
import { storage } from "@/shared/utils/local-storage";
import { StateCreator } from "zustand";

export interface UserSlice {
  user: {
    id: string | null;
    isAuthenticated: boolean;
    isAnonymous: boolean;
    loading?: boolean;
    storeInitialized: boolean;
    subscription: SubscriptionRow | null;
    dbLocked: boolean;
    set: (setting: Omit<Partial<UserSlice["user"]>, "set">) => void;
    clear: () => void;
  };
}

const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (set) => ({
  user: {
    id: null,
    isAuthenticated: false,
    isAnonymous: false,
    loading: true,
    storeInitialized: true,
    subscription: null,
    dbLocked: false,
    settings: storage.getUserSettings(),
    set: (user) => set((state) => ({ user: { ...state.user, ...user } })),
    clear: () =>
      set((state) => {
        deleteStore();
        clearKeyFromDB();

        return { user: { ...state.user, id: null, isAuthenticated: false, isAnonymous: false } };
      }),
  },
});

export default createUserSlice;
